import {alertValidation} from "../util/alertValidation";
import Swal from "sweetalert2";

export const audioValidation = (response, create, fn) => {
    // if (response.data.data === null) {
    //     alertValidation('필수 입력값을 기제ㅐ');
    // }
    if (response.data.message.length > 15) {
        Swal.fire({
            title: '',
            text: `관리자에게 문의해주세요. \n ${response.data.data !== null ? response.data.data : response.data.message}`,
            icon: 'warning',
            confirmButtonText: '확인',
        }).then(result => {
            return false
        });
    }
    switch (response.data.message) {
        case "audio_001"
        :   alertValidation('해당하는 중제목의 데이터가 없습니다.', fn);
            return false;
        case "audio_002"
        :   alertValidation('해당하는 타입이 없습니다.', fn);
            return false;
        case "audio_003"
        :   alertValidation('비밀번호를 입력해주세요.', fn);
            return false;
        case "audio_004"
        :   alertValidation('오디오 파일이 누락되었습니다.', fn);
            return false;
        case "audio_005"
        :   alertValidation('이미지 파일이 누락되었습니다.', fn);
            return false;
        case "audio_006"
        :   alertValidation('지도 이미지 파일이 누락되었습니다.', fn);
            return false;
        case "audio_007"
        :   alertValidation('조회하려는 오디오 데이터가 없습니다.', fn);
            return false;
        case "audio_008"
        :   alertValidation('수정하려는 중제목 데이터가 없습니다.', fn);
            return false;
        case "audio_009"
        :   alertValidation('수정하려는 오디오 데이터가 없습니다.', fn);
            return false;
        case "audio_010"
        :   alertValidation('삭제하려는 오디오 데이터가 없습니다.', fn);
            return false;
        case "audio_011"
        :   alertValidation('시각장애인용 이미지 대체문구가 누락되었습니다.', fn);
            return false;
        case "serverError"
        :   Swal.fire({
                title: '관리자에게 문의해주세요.',
                text: `${response.data.data}`,
                icon: 'warning',
                confirmButtonText: '확인',
            }).then(result => {
                fn();
                return false
            });
            break;
    }
}